import { Component, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { FAQItem } from '../../../models/database';
import { DatabaseService } from '../../services/database/database.service';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-faq-modal-component',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './faq-modal-component.component.html',
  styleUrl: './faq-modal-component.component.scss'
})
export class FaqModalComponentComponent  implements OnInit{

  faqs: FAQItem[] = [];

  constructor(
    private activeModal: NgbActiveModal,
    private databaseService: DatabaseService
  ){}

  ngOnInit(): void {
    // this.loadingFAQs();
  }

  // loadingFAQs(){
  //   this.databaseService.getFAQSection().subscribe((data) => {
  //     this.faqs = data
  //   })
  // }

  onCancel() {
    this.activeModal.dismiss();
  }

}
